import { BarChart3, Globe2, Home, Info, Map, Scale } from 'lucide-react';
import { useLayoutEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import BrandMark from '../components/public/BrandMark';

const links = [
  ['/', 'Oggi', Home],
  ['/confronta', 'Confronta', Scale],
  ['/mappa', 'Mappa', Map],
  ['/europa', 'Europa', Globe2],
  ['/metodologia', 'Dati', Info],
];

function DesktopNavItem({ to, label, Icon }) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className={({ isActive }) => `md-press inline-flex min-h-11 items-center gap-2 rounded-full px-5 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-md-primary focus-visible:ring-offset-2 ${isActive ? 'bg-md-primary text-md-on-primary shadow-md1' : 'text-md-on-surface-variant hover:bg-md-primary-container hover:text-md-on-primary-container'}`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </NavLink>
  );
}

function MobileNavItem({ to, label, Icon }) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className="group flex min-w-0 flex-1 flex-col items-center justify-center gap-1 py-2 text-[11px] font-medium text-md-on-surface-variant focus-visible:outline-none"
    >
      {({ isActive }) => (
        <>
          <span className={`grid h-8 w-full max-w-16 place-items-center rounded-full transition-all duration-300 ease-md ${isActive ? 'bg-md-secondary-container text-md-on-secondary-container' : 'text-md-on-surface-variant group-active:scale-95'}`}>
            <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
          </span>
          <span className={isActive ? 'font-bold text-md-on-surface' : ''}>{label}</span>
        </>
      )}
    </NavLink>
  );
}

export default function PublicLayout() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return (
    <div className="public-app min-w-0 overflow-x-clip pb-[88px] md:pb-0">
      <header className="sticky top-0 z-40 border-b border-md-outline-variant bg-md-surface">
        <div className="mx-auto flex h-[68px] max-w-6xl items-center gap-4 px-4 sm:px-6">
          <NavLink to="/" className="min-w-0 flex-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-md-primary focus-visible:ring-offset-2">
            <BrandMark />
          </NavLink>
          <nav className="hidden items-center gap-1.5 md:flex">
            {links.map(([to, label, Icon]) => <DesktopNavItem key={to} to={to} label={label} Icon={Icon} />)}
          </nav>
          <div className="hidden h-10 items-center gap-2 rounded-full bg-md-surface-container px-4 text-xs font-medium text-md-on-surface-variant *lg:flex">
            <BarChart3 className="h-4 w-4 text-md-secondary" />
            Storico giornaliero MIMIT
          </div>
        </div>
      </header>

      <main className="min-w-0"><Outlet /></main>

      <nav className="fixed inset-x-0 bottom-0 z-50 flex min-h-[80px] border-t border-md-outline-variant bg-md-surface px-2 pb-[env(safe-area-inset-bottom)] md:hidden">
        {links.map(([to, label, Icon]) => <MobileNavItem key={to} to={to} label={label} Icon={Icon} />)}
      </nav>

      <footer className="mt-16 hidden bg-md-secondary text-md-on-secondary md:block">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-8 px-6 py-9">
          <BrandMark />
          <p className="max-w-xl text-right text-sm leading-6">MIMIT per impianti e territori, MASE/SISEN per la composizione nazionale, Commissione europea per il confronto settimanale tra Paesi. Le metodologie restano distinte.</p>
        </div>
      </footer>
    </div>
  );
}
